import React, { useEffect, useState } from 'react'
import { Grid, GridColumn as Column, GridColumn } from "@progress/kendo-react-grid";
import { useTranslation } from '../../../locale/useTranslation';
import BossDialog from '../../../components/BossDialog';
import { DateCell, DateOnlyCell, LocalDateTimeColumn } from '../../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import { CheckboxCell } from '../../../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell';
import { COLUMNSTYPE, ENTITYNAME, LOCALSTORAGE_KEY, OFFER_STATUS } from '../../../framework/constant/constant';
import { utility } from '../../../framework/utility/utilityProvider';
import { Loader } from '../../../framework/forms/helpercomponents/Loader';
import { TimeCell } from '../../../framework/forms/helpercomponents/CustomGridCells/TimeCell';
import { ImageCell } from '../../../framework/forms/helpercomponents/CustomGridCells/ImageCell';
import { LookupCell } from '../../../framework/forms/helpercomponents/CustomGridCells/LookupCell';
import { ArrayCell } from '../../../framework/forms/helpercomponents/CustomGridCells/ArrayCell';
import { HrefCell, HyperLinkCell } from '../../../framework/forms/helpercomponents/CustomGridCells/HrefCell';
import { EnumCell, SIDEnumCell } from '../../../framework/forms/helpercomponents/CustomGridCells/EnumCell';
import { arrayEnumCell, daysCell, PlatformCell } from '../../../framework/forms/helpercomponents/CustomGridCells/PlatformCell';
import MyStatusCell from '../../../components/MyStatusCell';
import { IconCell } from '../../../framework/forms/helpercomponents/CustomGridCells/IconCell';
import { colorCell } from '../../../framework/forms/helpercomponents/CustomGridCells/ColorCell';
import { TextWithIconCell } from '../../../framework/forms/helpercomponents/CustomGridCells/TextWithIconCell';
import { ContentArrayImageCell } from '../../../framework/forms/helpercomponents/CustomGridCells/ContentArrayImageCell';
import castTypeCell from '../../../framework/forms/helpercomponents/CustomGridCells/CastTypeCell';
import * as API from '../../../framework/API/api';

const OfferGridCollection = (props) => {

    const { onClose, data = [] } = props;

    const lang = useTranslation();
    const [columns, setColumns] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        setIsLoading(true);
        let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
        let columns = await API.getFormData(ENTITYNAME.OFFER, currentUserId);
        setColumns(columns);
        setGridData(data);
        setIsLoading(false);
    };

    const MyDatalookupCell = (props) => (
        <LookupCell {...props} dataColumns={columns} />
    );

    const MyCheckBoxCell = (props) => {
        const value = props?.dataItem?.[props.field];
        return (
            <td style={{ marginLeft: "10px" }}>
                {value === 1 ? 'Yes' : 'No'}
            </td>
        );
    };

    const StatusCell = (props) => {
        const { dataItem = {}, field } = props;

        let value = utility.getNestedValue(dataItem, field);
        let title = utility.getKeyByValue(OFFER_STATUS, value);
        let tileBackColor = "";

        switch (value) {
            case OFFER_STATUS.Active:
                tileBackColor = "#63AA43";
                break;
            case OFFER_STATUS.Upcoming:
                tileBackColor = "#F8A506";
                break;
            default:
                tileBackColor = "#E72929";
                break;
        }

        return (<td style={{ padding: "3px" }}>
            <MyStatusCell {...props} style={{ width: "100px", }} title={title} tileBackColor={tileBackColor} />
        </td>);
    };

    return (
        <BossDialog title={`${lang.offers_label} (${data?.length})`} onClose={onClose} width={"60vw"}>
            {isLoading ? <Loader height="60vh" /> :
                <Grid data={gridData} style={{ height: "60vh", marginTop: "5px" }}>
                    {columns.map((column, index) => {
                        if (column.type === COLUMNSTYPE.date) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={DateOnlyCell}
                                    title={column.label}
                                    width={column.width ?? 200}
                                    sortable={true}
                                />
                            );
                        } else if (column.type === COLUMNSTYPE.datetime) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={DateCell}
                                    title={column.label}
                                    width={column.width ?? 200}
                                    sortable={true}
                                />
                            );
                        } else if (column.name.includes("Duration") || column.type == COLUMNSTYPE.time) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={TimeCell}
                                    title={column.label}
                                    width={column.width ?? 200}
                                    sortable={true}
                                />
                            );
                        } else if (column.name === "SID") {
                            return;
                        } else if (column.type === COLUMNSTYPE.image) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={(p) => ImageCell({ ...p, title: column.label })}
                                    title={column.label}
                                    width={column.width ?? 100}
                                    sortable={false}
                                />
                            );
                        } else if (column.type === COLUMNSTYPE.select) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={MyDatalookupCell}
                                    title={column.label}
                                    width={column.width ?? 200}
                                    sortable={false}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.checkbox) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={CheckboxCell}
                                    title={column.label}
                                    width={column.width ?? 80}
                                    sortable={false}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.array) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={ArrayCell}
                                    title={column.label}
                                    width={column.width ?? 200}
                                    format={column.format ?? "Description"}
                                    sortable={false}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.href) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={HrefCell}
                                    title={column.label}
                                    width={column.width ?? 200}
                                    format={column.format}
                                    sortable={false}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.hyperlink) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={HyperLinkCell}
                                    title={column.label}
                                    width={column.width ?? 200}
                                    format={column.format}
                                    sortable={false}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.enum) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={EnumCell}
                                    title={column.label}
                                    width={column.width ?? 200}
                                    format={column.format ?? "Description"}
                                    sortable={true}
                                />
                            );
                        } else if (column.type === COLUMNSTYPE.platform) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={PlatformCell}
                                    title={column.label}
                                    width={column.width ?? 200}
                                    sortable={false}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.status) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={StatusCell}
                                    title={column.label}
                                    width={column.width ?? 200}
                                    sortable={false}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.localdatetime) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={LocalDateTimeColumn}
                                    title={column.label}
                                    width={column.width ?? 200}
                                    sortable={true}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.icon) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={IconCell}
                                    title={column.label}
                                    width={column.width ?? 80}
                                    sortable={false}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.arrayenum) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={arrayEnumCell}
                                    title={column.label}
                                    width={column.width ?? 80}
                                    sortable={false}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.color) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={colorCell}
                                    title={column.label}
                                    width={column.width ?? 80}
                                    sortable={false}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.day) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={daysCell}
                                    title={column.label}
                                    width={column.width ?? 80}
                                    sortable={false}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.textWithIcon) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={TextWithIconCell}
                                    title={column.label}
                                    width={column.width ?? 200}
                                    sortable={false}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.imageArrayCell) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={ContentArrayImageCell}
                                    title={column.label}
                                    width={column.width ?? 350}
                                    sortable={false}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.castType) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={castTypeCell}
                                    title={column.label}
                                    width={column.width ?? 80}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.SIDEnum) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={(props) => SIDEnumCell({ ...props, fk_entityName: column.fk_entityName, fk_field: column.fk_field })}
                                    title={column.label}
                                    width={column.width ?? 80}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.boolean) {
                            return (
                                <GridColumn
                                    key={index}
                                    field={column.name}
                                    cell={MyCheckBoxCell}
                                    title={column.label}
                                    width={column.width ?? 80}
                                />
                            );
                        }
                        else {
                            return (
                                column.type !== COLUMNSTYPE.hidden && (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                )
                            );
                        }
                    })}
                </Grid>}
        </BossDialog>
    );
};

export default OfferGridCollection;